const EMOJI_TYPE = "wix-draft-plugin-emoji";
const emojiModals = {
  insert: `${EMOJI_TYPE}.insert`
};

export { EMOJI_TYPE, emojiModals };
//# sourceMappingURL=types.js.map
